"use client";

import React from "react";
import { usePathname } from "next/navigation";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "@/redux/store";
import { logoutAll } from "@/redux/slices/authSlice";
import { useRouter } from "next/navigation";
import { LogOut, Bell } from "lucide-react";

// Map pathnames to readable titles
function getPageTitle(pathname: string): string {
  if (pathname === "/admin") return "Dashboard";
  if (pathname === "/admin/master/user") return "Master / User";
  if (pathname === "/admin/master/usertype") return "Master / User Type";
  if (pathname === "/admin/master/customer") return "Master / Customer";
  if (pathname === "/admin/master/testimonial") return "Master / Testimonial";
  if (pathname === "/admin/product") return "Product";
  if (pathname === "/admin/orders") return "Orders";
  if (pathname === "/admin/temp-bookings") return "Temporary Booking List";
  if (pathname === "/admin/pending-carts") return "Pending Carts Customer List";
  if (pathname === "/admin/inquiry") return "Inquiry";
  if (pathname === "/admin/report/order") return "Report / Order Report";
  return "Admin Panel";
}

export default function AdminHeader() {
  const pathname = usePathname();
  const dispatch = useDispatch<AppDispatch>();
  const router = useRouter();
  const { user } = useSelector((state: RootState) => state.auth);

  const handleLogout = () => {
    dispatch(logoutAll());
    router.replace("/admin/login/");
  };

  const employeeName = user?.userName || user?.name || "Employee";

  return (
    <header className="h-16 bg-white border-b border-border-1 flex items-center justify-between px-4 sm:px-6 flex-shrink-0 relative z-10 shadow-sm no-print">
      {/* Page title */}
      <div>
        <h1 className="text-sm sm:text-base font-semibold text-text-1 tracking-wide">
          {getPageTitle(pathname)}
        </h1>
        <p className="text-[10px] sm:text-[11px] text-text-3 tracking-wider">
          {typeof window !== "undefined" &&
            new Date().toLocaleDateString("en-IN", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
        </p>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-3">
        {/* Logout */}
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 ml-1 px-2.5 py-1.5 sm:px-3 sm:py-2 text-[10px] sm:text-xs font-bold text-text-2 border border-border-1 rounded-lg hover:bg-red-50 hover:text-red-500 hover:border-red-200 transition-all uppercase tracking-wider"
          title="Logout"
        >
          <LogOut size={14} className="sm:hidden" />
          <span className="hidden sm:flex items-center gap-1.5">
            <LogOut size={14} />
            Logout
          </span>
        </button>
      </div>
    </header>
  );
}
